module.exports = __webpack_public_path__ + "platform/static/media/diverse.0ed6cd50.png";